'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPulse = function IoIosPulse(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 22.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5c-1.2 0-2.1-0.8-2.4-1.8h-5.1c-0.2 0-0.5-0.2-0.6-0.4l-1.8-5.6-4.5 15.5c-0.1 0.2-0.3 0.4-0.6 0.4-0.3 0-0.5-0.2-0.6-0.5l-4.6-27.1-4.2 17.2c-0.1 0.3-0.3 0.5-0.6 0.5h-7.5v-1.2h7l4.9-19.7c0.1-0.3 0.3-0.4 0.6-0.4s0.5 0.2 0.6 0.5l4.6 27.3 4.2-14.9c0.1-0.2 0.3-0.3 0.6-0.3s0.5 0.1 0.6 0.3l2.4 7.2h4.6c0.2-1.1 1.2-2 2.4-2z' })
        )
    );
};

exports.default = IoIosPulse;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-pulse.js
// module id = 2494
// module chunks = 0